import React from "react";
import ContactList from "../../communicator/contactList";
import { setActiveChat } from "../../../../../../actions/CommunicatorActions";
import { useDispatch, useSelector } from "react-redux";
import { EmptyHomeScreen } from "../../../../../stylized/EmptyHomeScreen";
import { setActivePage } from "../../../../../../actions";
const NewChat = () => {
    const dispatch = useDispatch();
    const chatList = useSelector((state) => state.chatList);
    const handleChatSelection = (chatDetails, chat, index) => {
        if (!chatDetails) dispatch(setActivePage("Communicator"));
        else {
            let chatObj = { chatDetails, chat, selectedContactIndex: index };
            dispatch(setActiveChat(chatObj));
            dispatch(setActivePage("Communicator"));
        }
    };

    return (
        <>
            {chatList.length === 0 ? (
                <>
                    <EmptyHomeScreen
                        heading="Information Feed"
                        image="./images/home.file.svg"
                        subTitle="No information yet!"
                    />
                </>
            ) : (
                <div>
                    <span style={{ width: "auto" }} className="heading">
                        Information Feed
                    </span>

                    <div className="invisibleScroller newChat">
                        <ContactList
                            contactList={
                                chatList !== undefined && chatList !== null
                                    ? chatList
                                    : []
                            }
                            handleChatSelection={handleChatSelection}
                        ></ContactList>
                    </div>
                </div>
            )}
        </>
    );
};

export default NewChat;
